import React from "react";

function Nav() {
  return (
    <div>
      {" "}
      <div className="main-header">
        {/* Logo Header */}
        <div className="logo-header" data-background-color="dark">
          <a
            href="/"
            className="logo"
            style={{ fontSize: "27px", color: "#fff" }}
          >
            <img
              src="public/uploads/logo/dark.png"
              alt="logo"
              className="img-fluid"
              width="110px"
              height="90px"
            />
          </a>
          <button
            className="ml-auto navbar-toggler sidenav-toggler"
            type="button"
            data-toggle="collapse"
            data-target="collapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">
              <i className="icon-menu" />
            </span>
          </button>
          <button className="topbar-toggler more">
            <i className="icon-options-vertical" />
          </button>
          <div className="nav-toggle">
            <button className="btn btn-toggle toggle-sidebar">
              <i className="icon-menu" />
            </button>
          </div>
        </div>
        {/* End Logo Header */}
        {/* Navbar Header */}
        <nav
          className="navbar navbar-header navbar-expand-lg"
          data-background-color="dark"
        >
          {/* <span>Language:</span> */}
          <select
            className="custom-select lang-sel"
            style={{ width: "110px", border: "0px solid #0080db00" }}
            id="language"
            onchange="changeLanguageByButtonClick()"
          >
            <option value="en" selected>
              English
            </option>
            <option value="af">Afrikanns</option>
            <option value="sq">Albanian</option>
            <option value="ar">Arabic</option>
            <option value="hy">Armenian</option>
            <option value="eu">Basque</option>
            <option value="bn">Bengali</option>
            <option value="bg">Bulgarian</option>
            <option value="ca">Catalan</option>
            <option value="km">Cambodian</option>
            <option value="zh-CN">Chinese (Mandarin)</option>
            <option value="hr">Croation</option>
            <option value="cs">Czech</option>
            <option value="da">Danish</option>
            <option value="nl">Dutch</option>
            <option value="et">Estonian</option>
            <option value="fj">Fiji</option>
            <option value="fi">Finnish</option>
            <option value="fr">French</option>
            <option value="ka">Georgian</option>
            <option value="de">German</option>
            <option value="el">Greek</option>
            <option value="gu">Gujarati</option>
            <option value="he">Hebrew</option>
            <option value="hi">Hindi</option>
            <option value="hu">Hungarian</option>
            <option value="is">Icelandic</option>
            <option value="id">Indonesian</option>
            <option value="ga">Irish</option>
            <option value="it">Italian</option>
            <option value="ja">Japanese</option>
            <option value="jw">Javanese</option>
            <option value="ko">Korean</option>
            <option value="la">Latin</option>
            <option value="lv">Latvian</option>
            <option value="lt">Lithuanian</option>
            <option value="mk">Macedonian</option>
            <option value="ms">Malay</option>
            <option value="ml">Malayalam</option>
            <option value="mt">Maltese</option>
            <option value="mi">Maori</option>
            <option value="mr">Marathi</option>
            <option value="mn">Mongolian</option>
            <option value="ne">Nepali</option>
            <option value="no">Norwegian</option>
            <option value="fa">Persian</option>
            <option value="pl">Polish</option>
            <option value="pt">Portuguese</option>
            <option value="pa">Punjabi</option>
            <option value="qu">Quechua</option>
            <option value="ro">Romanian</option>
            <option value="ru">Russian</option>
            <option value="sm">Samoan</option>
            <option value="sr">Serbian</option>
            <option value="sk">Slovak</option>
            <option value="sl">Slovenian</option>
            <option value="es">Spanish</option>
            <option value="sw">Swahili</option>
            <option value="sv">Swedish </option>
            <option value="ta">Tamil</option>
            <option value="tt">Tatar</option>
            <option value="te">Telugu</option>
            <option value="th">Thai</option>
            <option value="bo">Tibetan</option>
            <option value="to">Tonga</option>
            <option value="tr">Turkish</option>
            <option value="uk">Ukranian</option>
            <option value="ur">Urdu</option>
            <option value="uz">Uzbek</option>
            <option value="vi">Vietnamese</option>
            <option value="cy">Welsh</option>
            <option value="xh">Xhosa</option>
          </select>
          <div className="container-fluid">
            <div className="text-center d-md-block d-none">
              <a
                href="/depositpage"
                className="pricing-action btn btn-warning btn-sm"
              >
                Fund your Account
              </a>{" "}
              &nbsp;
              <a
                href="/withdrawal"
                className="pricing-action btn btn-danger btn-sm"
              >
                Withdraw Funds
              </a>
            </div>
            <ul className="navbar-nav topbar-nav ml-md-auto align-items-center">
              <li className="nav-item hidden-caret">
                <form
                  action="javascript:void(0)"
                  method="post"
                  id="styleform"
                  className="form-inline"
                >
                  <div className="form-group">
                    <label className="style_switch">
                      <input
                        name="style"
                        id="style"
                        type="checkbox"
                        defaultValue="true"
                        className="modes"
                      />
                      <span className="slider round" />
                    </label>
                  </div>
                  <input
                    type="hidden"
                    name="_token"
                    defaultValue="rffaIxjXY1WrgEiXI8NhxER8AQMHoLeFYVeOLpuY"
                  />
                </form>
              </li>
              <li className="nav-item hidden-caret">
                <div id="google_translate_element" />
              </li>
              <li className="nav-item dropdown hidden-caret">
                <a
                  className="nav-link"
                  data-toggle="dropdown"
                  href="#"
                  aria-expanded="false"
                >
                  <i className="fas fa-user" />
                </a>
                <ul className="dropdown-menu dropdown-user animated fadeIn">
                  <div className="dropdown-user-scroll scrollbar-outer">
                    <li>
                      <div className="user-box">
                        <div className="u-text">
                          <h4>apexyeild</h4>
                          <p className="text-muted">
                            apexyeild@gmail.com
                          </p>
                          <a
                            href="/account-settings"
                            className="btn btn-xs btn-secondary btn-sm"
                          >
                            Account Settings
                          </a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="dropdown-divider" />
                      <a
                        className="dropdown-item"
                        href="/depositpage"
                      >
                        Deposit
                      </a>
                      <a
                        className="dropdown-item"
                        href="/withdrawal"
                      >
                        Withdraw
                      </a>
                       <a
                        className="dropdown-item"
                        href="/deposit"
                      >
                        Buy Plan
                      </a> *
                      <div className="dropdown-divider" />
                      <a
                        className="dropdown-item"
                        href="logout"
                        onclick="event.preventDefault();
                                    document.getElementById('logout-form').submit();"
                      >
                        Logout
                      </a>
                      <form
                        id="logout-form"
                        action="logout"
                        method="POST"
                        style={{ display: "none" }}
                      >
                        <input
                          type="hidden"
                          name="_token"
                          defaultValue="rffaIxjXY1WrgEiXI8NhxER8AQMHoLeFYVeOLpuY"
                        />
                      </form>
                    </li>
                  </div>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
        {/* End Navbar */}
      </div>
      {/* Stored in resources/views/child.blade.php */}
      {/* Sidebar */}
      <div className="sidebar sidebar-style-2" data-background-color="light">
        <div className="sidebar-wrapper scrollbar scrollbar-inner">
          <div className="sidebar-content">
            <div className="user">
              <div className="info">
                <a
                  data-toggle="collapse"
                  href="#collapseExample"
                  aria-expanded="true"
                >
                  <span>
                    apexyeild
                    <span className="caret" />
                  </span>
                </a>
                <div className="clearfix" />
                <div className="collapse in" id="collapseExample">
                  <ul className="nav">
                    <li>
                      <a href="/account-settings">
                        <span className="link-collapse">Account Settings</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <ul className="nav nav-primary">
              <li className="nav-item active">
                <a href="/dashboards">
                  <p>Dashboard</p>
                </a>
              </li>
              <li className="nav-item d-md-none  ">
                <a href="/depositpage">
                  <p>Deposit</p>
                </a>
              </li>
              <li className="nav-item d-md-none  ">
                <a href="/withdrawal">
                  <p>Withdraw</p>
                </a>
              </li>
              <li className="nav-item ">
                <a href="/tradinghistory">
                  <p>Profit Tracker</p>
                </a>
              </li>
              <li className="nav-item ">
                <a href="/accounthistory">
                  <p>User history</p>
                </a>
              </li>
              <li className="nav-item ">
                <a href="/deposit">
                  <p>Investment Plans</p>
                </a>
              </li> 
              <li className="nav-item ">
                <a href="/tradinghistory">
                  <p>View Active Plans</p>
                </a>
              </li>
              <li className="nav-item ">
                <a href="/referuser">
                  <p>Refferals</p>
                </a>
              </li>
              <li className="nav-item ">
                <a href="/support">
                  <i className="fa fa-life-ring" aria-hidden="true" />
                  <p>Contact Support</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Nav;
